(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["08l-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  var DASH=' \u2014 ', CHECK=' \u2713';

  // ---- prev/next nav ------------------------------------------------------
  // Server-rendered links exist only inside a collection context. On a plain
  // /products/<handle> URL we resolve the neighbours from the category collection
  // and cache the handle list per collection for the rest of the session.
  (function(){
    var nav=document.querySelector('.olp__nav'); if(!nav) return;
    var prevEl=nav.querySelector('.olp__nav-prev'), nextEl=nav.querySelector('.olp__nav-next');
    var col=nav.getAttribute('data-col'), cur=nav.getAttribute('data-cur');
    /* 2026-11-02: the sort + filters the shopper picked on this collection (saved by
       layout/theme.liquid). Shopify's collection.next_product ignores them, so when
       set we resolve the neighbours in that order instead. */
    var q=''; try{ q=sessionStorage.getItem('olpq:'+col)||''; }catch(e){}
    if(q){ var back=nav.querySelector('.olp__nav-back'); if(back) back.setAttribute('href', back.getAttribute('href').split('?')[0]+'?'+q); }

    function setName(link){
      var nameEl=link.querySelector('.olp__nav-name'); if(!nameEl) return;
      var m=(link.getAttribute('href')||'').match(/\/products\/([^/?#]+)/); if(!m) return;
      fetch('/products/'+m[1]+'.js').then(function(r){return r.json();})
        .then(function(p){ if(p&&p.title) nameEl.textContent=p.title; }).catch(function(){});
    }
    function apply(link, item){
      if(!link||!item) return;
      link.setAttribute('href','/collections/'+col+'/products/'+item.h);
      link.querySelector('.olp__nav-name').textContent=item.t||'';
      link.removeAttribute('hidden');
    }
    /* SPEED (2026-10-26). Was /collections/<col>/products.json - every product's
       full record, ~460-590 KB for Diagrams - just to read two names. Now
       templates/collection.olpnav.liquid returns only [handle, title] pairs,
       250 per page (~5 KB gzipped), and we stop at the page that holds the
       current product (plus the next page only when it sits at a page edge).
       Pages are cached for the session, so the next product is usually free.
       Order = the collection's own sort, the same order collection.previous_product
       uses on the server-rendered path. */
    function navPage(n,qs){
      var key='olpnav:'+col+':'+(qs||'')+':'+n;
      try{ var c=sessionStorage.getItem(key); if(c) return Promise.resolve(JSON.parse(c)); }catch(e){}
      return fetch('/collections/'+col+'?view=olpnav&page='+n+(qs?'&'+qs:''))
        .then(function(r){ return r.ok?r.json():null; })
        .then(function(d){
          if(!d||!d.items) return null;
          var pg={pages:d.pages, items:d.items.map(function(x){ return {h:x[0],t:x[1]}; })};
          try{ sessionStorage.setItem(key, JSON.stringify(pg)); }catch(e){}
          return pg;
        });
    }
    function findNeighbours(qs){
      var prevLast=null;
      function step(n){
        return navPage(n,qs).then(function(pg){
          if(!pg) return null;
          var it=pg.items, i=-1;
          for(var k=0;k<it.length;k++){ if(it[k].h===cur){ i=k; break; } }
          if(i<0){
            if(n>=pg.pages || n>=8) return null;
            prevLast=it.length?it[it.length-1]:prevLast;
            return step(n+1);
          }
          var res={prev: i>0?it[i-1]:prevLast, next: i<it.length-1?it[i+1]:null};
          if(res.next || n>=pg.pages) return res;
          return navPage(n+1,qs).then(function(nx){ res.next=(nx&&nx.items[0])||null; return res; });
        });
      }
      return step(1);
    }

    var needResolve=false;
    if(q){ [prevEl,nextEl].forEach(function(l){ if(!l) return; l.removeAttribute('href'); l.setAttribute('hidden',''); }); needResolve=true; }
    else [prevEl,nextEl].forEach(function(l){ if(!l) return; if(l.getAttribute('href')) setName(l); else needResolve=true; });
    if(!needResolve || !col || !cur) return;

    findNeighbours(q).then(function(nb){ return (nb||!q) ? nb : findNeighbours(''); }).then(function(nb){
      if(!nb) return;
      if(prevEl && !prevEl.getAttribute('href') && nb.prev) apply(prevEl, nb.prev);
      if(nextEl && !nextEl.getAttribute('href') && nb.next) apply(nextEl, nb.next);
    }).catch(function(){});
  })();

  var form=document.getElementById('olpForm'); if(!form) return;
  var variants=[]; try{ variants=JSON.parse(form.dataset.variants); }catch(e){}
  function ud(s){ return decodeURIComponent((s||'').replace(/\+/g,' ')); }
  var prices={};
  (form.dataset.prices||'').split('|').forEach(function(pair){
    var i=pair.indexOf(':'); if(i>0) prices[pair.slice(0,i)]=ud(pair.slice(i+1));
  });
  /* variantId -> selling plan id, for subscription products (memberships). */
  var plans={};
  (form.dataset.plans||'').split('|').forEach(function(pair){
    var i=pair.indexOf(':'); if(i>0) plans[pair.slice(0,i)]=pair.slice(i+1);
  });
  var images={};
  (form.dataset.images||'').split('|').forEach(function(pair){
    var i=pair.indexOf(':'); if(i>0) images[pair.slice(0,i)]=ud(pair.slice(i+1));
  });
  /* variantId -> formatted member price. Absent for any variant the member
     snippet refused, which is how a $0 variant hides the line. */
  var memberPrices={};
  (form.dataset.memberPrices||'').split('|').forEach(function(pair){
    var i=pair.indexOf(':'); if(i>0) memberPrices[pair.slice(0,i)]=ud(pair.slice(i+1));
  });
  var memberEl=document.getElementById('olpMember');     /* null when the product does not qualify */
  var memberAmt=memberEl && memberEl.querySelector('[data-member-amount]');
  var idInput=document.getElementById('olpVariantId');
  var priceEl=document.getElementById('olpPrice');
  var addBtn=document.getElementById('olpAdd');          /* null on blends */
  var addLabel=document.getElementById('olpAddLabel');   /* null on blends */
  var blendBtn=document.querySelector('.ol-blend-btn');  /* null everywhere else */
  var msg=document.getElementById('olpMsg');

  function selectedOptions(){
    var opts=[];
    form.querySelectorAll('.olp__opt').forEach(function(fs){
      var r=fs.querySelector('input:checked'); opts.push(r?r.value:null);
    });
    return opts;
  }
  function findVariant(opts){
    /* Single-variant products render NO option fieldsets, because the synthetic
       "Default Title" option is suppressed in the markup above. So
       selectedOptions() comes back empty, while the variant still reports
       options:["Default Title"] (length 1) - the length check below could never
       match and every heavy showed "Unavailable". There is exactly one variant
       in that case, so use it. */
    if(!opts.length) return variants[0];
    return variants.filter(function(v){
      return v.options.length===opts.length && v.options.every(function(o,i){ return o===opts[i]; });
    })[0];
  }
  function money(v){ return prices[v.id] || ('$'+(v.price/100).toFixed(2)); }
  /* print + frame, written in the shop's own money format ("$ 108.00") */
  function withFrame(v, fr){
    var c=(v.price+fr.price)/100;
    var n=c.toLocaleString('en-US',{minimumFractionDigits:2, maximumFractionDigits:2});
    return money(v).replace(/[\d.,]+/, n);
  }
  function base(u){ return (u||'').split('?')[0]; }
  var imgSwapId=0;   /* latest variant photo swap wins (see update()) */

  /* INCOMPATIBLE COMBINATIONS. "Fine Art Poster Print" is never offered in
     "4 x 6" (Ryan: never show Fine Art 4x6). The product DATA may still carry
     sold-out Fine-Art/4x6 variants; this HIDES the 4x6 size pill whenever Fine
     Art is selected, so the bad combo can never be seen or chosen on this PDP.
     The old fix lived in theme.liquid but only targeted the STOCK picker
     (input names "Material-..."); it never fired on this custom picker, which
     is why 4x6 Fine Art reappeared once products moved to the 08l template.
     Exact-string match, so blends (Product="Fine Art", sizes 30x20/60x40) are
     unaffected. Add more {when,hide} rules here if other combos need it. */
  var INCOMPAT = [{ when: 'Fine Art Poster Print', hide: '4 x 6' }];
  function applyIncompat(){
    var sel = selectedOptions();
    var active = INCOMPAT.filter(function(r){ return sel.indexOf(r.when) !== -1; });
    form.querySelectorAll('.olp__opt').forEach(function(fs){
      fs.querySelectorAll('.olp__pill').forEach(function(pill){
        var input = pill.querySelector('input'); if(!input) return;
        var hideThis = active.some(function(r){ return r.hide === input.value; });
        pill.style.display = hideThis ? 'none' : '';
        if(hideThis && input.checked){
          input.checked = false;
          var sibs = fs.querySelectorAll('.olp__pill');
          for(var k=0;k<sibs.length;k++){
            var si = sibs[k].querySelector('input');
            if(si && sibs[k].style.display !== 'none'){ si.checked = true; break; }
          }
        }
      });
    });
  }

  // grey out option values that have no AVAILABLE variant given the other picks
  function updateOptionAvailability(){
    var sel=selectedOptions();
    form.querySelectorAll('.olp__opt').forEach(function(fs, gi){
      fs.querySelectorAll('.olp__pill').forEach(function(pill){
        var input=pill.querySelector('input'); if(!input) return;
        var val=input.value;
        /* A pick that INCOMPAT will move away from does not count against this
           value (2026-10-28). With Metal + 4 x 6 selected, Fine Art has no 4 x 6,
           but choosing Fine Art moves the size to 12 x 18 anyway - so Fine Art
           must not be struck out. Any selection this value would hide is a
           wildcard here. */
        var hides=INCOMPAT.filter(function(r){ return r.when===val; }).map(function(r){ return r.hide; });
        var ok=variants.some(function(v){
          if(!v.available || v.options[gi]!==val) return false;
          for(var j=0;j<sel.length;j++){
            if(j===gi || sel[j]==null || hides.indexOf(sel[j])!==-1) continue;
            if(v.options[j]!==sel[j]) return false;
          }
          return true;
        });
        pill.classList.toggle('is-soldout', !ok);
      });
    });
  }

  function update(){
    applyIncompat();   /* hide impossible combos (Fine Art 4x6) + fix selection BEFORE resolving */
    form.querySelectorAll('.olp__opt').forEach(function(fs){
      fs.querySelectorAll('.olp__pill').forEach(function(l){ l.classList.toggle('is-sel', !!l.querySelector('input:checked')); });
    });
    updateOptionAvailability();
    var v=findVariant(selectedOptions());
    /* On a BLEND there is no #olpAdd at all - the button is "Build your blend".
       Every addBtn/addLabel touch below must be null-guarded or the whole
       variant picker throws on the first click and stops working. */
    if(!v){ if(addBtn){ addBtn.disabled=true; addLabel.textContent='Unavailable'; } msg.textContent=''; return; }
    idInput.value=v.id;
    /* one-line spec under Material follows the selected material */
    var specEl=document.getElementById('olpSpec');
    if(specEl){
      var mats=selectedOptions();
      var sp=mats.indexOf('Premium Metal Print')!==-1 ? specEl.getAttribute('data-metal') : (mats.indexOf('Fine Art Poster Print')!==-1 ? specEl.getAttribute('data-fa') : '');
      specEl.textContent=sp; specEl.style.display=sp?'':'none';
    }
    /* FRAME ROW (frame-pick-08l.liquid): when a frame is chosen the price and the
       button show print + frame. sync() also shows/hides the row for this variant. */
    var fr=window.OLFramePick ? window.OLFramePick.sync(v, update) : null;
    var shown=fr ? withFrame(v, fr) : money(v);
    if(fr){
      priceEl.textContent=shown;
      var note=document.createElement('span'); note.className='olp__price-note';
      note.textContent='with '+window.OLFramePick.label();
      priceEl.appendChild(note);
    } else priceEl.textContent=shown;
    /* The member line follows the size: a 24x36 shows the 24x36 member price. */
    if(memberEl){
      var mp=memberPrices[v.id];
      if(mp){ if(memberAmt) memberAmt.textContent=mp; memberEl.hidden=false; }
      else{ memberEl.hidden=true; }
      /* With a frame chosen the big price is print + frame, so say the member
         price is the print's, not the total (2026-10-28). */
      if(memberAmt){
        var mpp=memberEl.querySelector('[data-member-print]');
        if(!mpp){ mpp=document.createElement('span'); mpp.setAttribute('data-member-print',''); mpp.textContent=' for the print'; memberAmt.parentNode.insertBefore(mpp, memberAmt.nextSibling); }
        mpp.style.display=fr?'':'none';   /* not [hidden]: the member line's own CSS sets display on its spans */
      }
    }
    /* keep the blend popup pointed at the variant the customer actually picked */
    if(blendBtn) blendBtn.setAttribute('data-variant', v.id);
    if(addBtn){
      if(v.available){ addBtn.disabled=false; addLabel.textContent='Add to cart'+DASH+shown; }
      else{ addBtn.disabled=true; addLabel.textContent=addBtn.getAttribute('data-sold-label')||'Unavailable'; }
    }
    // swap main image to this variant's image (if it has one)
    var mi=document.querySelector('.olp__frame img');
    var url=images[v.id];
    if(mi && url){
      var b=base(url);
      /* NO BLINK (2026-10-28, Ryan saw the photo flicker on his phone).
         1. Same picture already showing (always true on page load: Liquid printed
            this variant's photo with a srcset) - leave the image alone. It used to
            drop the srcset and re-load the same file at 1400px ~30 ms after first
            paint, and iPhone Safari blanks the image while the new src loads.
         2. A different picture - load it first, swap once it is ready, so there is
            never an empty frame. imgSwapId drops a slow load that a later pick
            has overtaken. */
      if(base(mi.currentSrc||mi.src).replace(/^https?:/,'')!==b.replace(/^https?:/,'')){
        var my=++imgSwapId, pre=new Image();
        pre.onload=pre.onerror=function(){ if(my!==imgSwapId) return; mi.removeAttribute('srcset'); mi.src=url; };
        pre.src=url;
      }
      document.querySelectorAll('.olp__thumb').forEach(function(x){ x.classList.toggle('is-sel', base(x.dataset.full)===b); });
      thumbIntoRow();
    }
    try{ var u=new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }catch(e){}
  }

  /* METAL STARTS AT 4 x 6 (Ryan 2026-10-28). Picking Premium Metal moves the
     size to 4 x 6 - the $49 entry metal - when that size exists and is
     available in the chosen style. Only on the shopper's own switch to metal;
     a page opened on a metal variant keeps its size. Back to Fine Art, the
     INCOMPAT rule hides 4 x 6 and moves the size to the first paper size. */
  function metalTo4x6(){
    var four=[].slice.call(form.querySelectorAll('.olp__opt input')).filter(function(i){ return i.value==='4 x 6'; })[0];
    if(!four || four.checked) return;
    var sel=selectedOptions(), gi=-1;
    form.querySelectorAll('.olp__opt').forEach(function(fs,i){ if(fs.contains(four)) gi=i; });
    if(gi<0) return;
    sel[gi]='4 x 6';
    var v=findVariant(sel);
    if(v && v.available) four.checked=true;
  }
  form.addEventListener('change', function(e){
    if(!e.target.matches('input[type="radio"]')) return;
    if(e.target.value==='Premium Metal Print') metalTo4x6();
    update();
  });

  /* Phones show the thumbnails as one swipeable row (2026-10-26). When a variant
     swaps the photo, slide the row so its thumbnail is in view. Moves the row only,
     never the page. */
  function thumbIntoRow(){
    var row=document.querySelector('.olp__thumbs'), t=row && row.querySelector('.olp__thumb.is-sel');
    if(!t || row.scrollWidth<=row.clientWidth) return;
    var d=t.getBoundingClientRect().left-row.getBoundingClientRect().left;
    if(d<0 || d+t.offsetWidth>row.clientWidth) row.scrollLeft+=d-8;
  }

  var mainImg=document.querySelector('.olp__frame img');
  document.querySelectorAll('.olp__thumb').forEach(function(t){
    t.addEventListener('click', function(){
      if(mainImg){ mainImg.removeAttribute('srcset'); mainImg.src=t.dataset.full; }
      document.querySelectorAll('.olp__thumb').forEach(function(x){ x.classList.remove('is-sel'); });
      t.classList.add('is-sel');
    });
  });

  // quantity stepper
  var qtyInput=document.getElementById('olpQty');
  function getQty(){ var q=parseInt(qtyInput&&qtyInput.value,10); return (q&&q>0)?q:1; }
  document.querySelectorAll('.olp__qbtn').forEach(function(b){
    b.addEventListener('click', function(){ qtyInput.value=Math.max(1, getQty()+parseInt(b.dataset.step,10)); });
  });
  if(qtyInput) qtyInput.addEventListener('change', function(){ qtyInput.value=getQty(); });

  // related airports via Shopify product recommendations
  var relWrap=document.getElementById('olpRelated');
  if(relWrap){
    var pid=relWrap.dataset.pid;
    var esc=function(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});};
    fetch('/recommendations/products.json?product_id='+pid+'&limit=4&intent=related')
      .then(function(r){ return r.json(); })
      .then(function(d){
        var items=(d&&d.products)||[];
        if(!items.length) return;
        document.getElementById('olpRelatedGrid').innerHTML=items.map(function(pr){
          var fi=pr.featured_image, u=(typeof fi==='string')?fi:((fi&&fi.src)||'');
          var img=u?('<img src="'+u+(u.indexOf('?')>-1?'&':'?')+'width=440" alt="" loading="lazy">'):'';
          return '<a class="olp__rcard" href="'+pr.url+'"><div class="olp__rart">'+img+'</div><div class="olp__rcap">'+esc(pr.title)+'</div></a>';
        }).join('');
        relWrap.hidden=false;
      }).catch(function(){});
  }

  function cartSectionIds(){
    var ids={};
    document.querySelectorAll('cart-items-component, cart-drawer-component, cart-icon').forEach(function(el){
      var sid=el.getAttribute('data-section-id'); if(!sid){ var h=el.closest('[data-section-id]'); sid=h&&h.getAttribute('data-section-id'); }
      if(sid) ids[sid]=1;
    });
    return Object.keys(ids);
  }
  function refreshCart(res){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      /* HORIZON 4.1.3: the cart icon + drawer listen for 'shopify:cart:lines-update'
         and read event.promise -> {cart:{totalQuantity}, detail:{itemCount}}.
         cart-drawer also checks event.action === 'add' to auto-open.
         Without this the item DOES add server-side but the bubble never changes
         and the drawer never opens - it looks like "add to cart is broken".
         The legacy 1.0.0 events below are kept: harmless, and keep this file
         working if it is ever pasted back onto the old theme. */
      /* FRAME OFFER FIRST, CART DRAWER AFTER (2026-10-01). The drawer is a
         top-layer <dialog> and would cover the frame-upsell popup. When
         frame-upsell.js says it will offer a frame for this add, repaint only
         ('update'); frame-upsell opens the drawer when its popup closes, or
         straight away if it decides not to show. If frame-upsell is not on the
         page, OLFrameUpsell is undefined and this is a plain 'add' as before. */
      var fu = window.OLFrameUpsell;
      var deferToFrame = !!(fu && fu.claims && res && res.items && res.items.some(function(it){ try{ return fu.claims(it); }catch(e){ return false; } }));
      try{
        var ev = new Event('shopify:cart:lines-update', {bubbles:true});
        ev.action = deferToFrame ? 'update' : 'add';
        ev.promise = Promise.resolve({
          cart: { totalQuantity: cart.item_count },
          detail: { itemCount: cart.item_count, source: 'olp', sections: (res && res.sections) || {} }
        });
        document.dispatchEvent(ev);
      }catch(e){}
      try{ document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:{},sourceId:'olp',data:{itemCount:cart.item_count,source:'olp',sections:(res&&res.sections)||{}}}})); }catch(e){}
      ['cart:refresh','cart:updated','cart:change'].forEach(function(n){ try{ document.documentElement.dispatchEvent(new CustomEvent(n,{bubbles:true,detail:{cart:cart}})); }catch(e){} });
    }).catch(function(){});
  }
  /* THE "REMOVE THE DISCOUNT" PROBLEM.
     Shopify's own 422 text tells the shopper to remove their discount, but the
     discount lives on the SESSION, not on a line item - so the cart can be
     completely empty and there is nothing on screen to remove. Ryan, correctly:
     "there are no discounts in my cart so the error makes no sense."

     /cart/clear.js does NOT drop a discount code; it survives an empty cart and
     silently blocks every heavy afterwards. The theme's own cart-discount.js
     removes codes by POSTing to /cart/update.js with `discount` set to the
     remaining codes, so an empty string clears them all. Verified live: heavy
     422 -> update discount:'' -> same heavy 200.

     So rather than repeating an instruction the shopper cannot act on, do it
     for them with one button. Only shown when the server's own message is
     about a discount; any other failure keeps the plain text path. */
  /* Shopify puts the human-readable rejection reason in a different key
     depending on the endpoint. Measured on this store:
       POST /cart/add.js  -> {"status":422,"message":"...","description":"..."}
       POST /cart/update  -> {"errors":"..."}
     and `errors` can also be an object of field -> [messages]. Read all three
     shapes, because guessing wrong means falling back to a generic line and
     losing the one sentence that actually tells the customer what to do. */
  function readCartError(body){
    if(!body) return '';
    var raw = body.description || body.message || body.errors;
    if(typeof raw === 'string') return raw;
    if(Object.prototype.toString.call(raw) === '[object Array]') return raw.join(' ');
    if(raw && typeof raw === 'object'){
      var out=[];
      for(var k in raw){ if(!Object.prototype.hasOwnProperty.call(raw,k)) continue;
        var v=raw[k];
        if(typeof v === 'string') out.push(v);
        else if(Object.prototype.toString.call(v) === '[object Array]') out.push(v.join(' '));
      }
      return out.join(' ');
    }
    return '';
  }

  /* A subscription variant is rejected outright without its selling plan, so
     attach it whenever the variant has one. Products with no plans are
     unaffected - the key is simply absent. */
  function buildItem(v){
    var item={ id:v.id, quantity:getQty() };
    var plan=plans[String(v.id)];
    if(plan) item.selling_plan=Number(plan);
    /* White Line picker (whiteline-08l.js): same variant, same price, the
       style rides on the line so the order says what to print.
       _art_image (2026-10-26) carries the White Line preview so the cart
       thumbnail (snippets/cart-products.liquid) and the frame offer
       (frame-upsell.js) show White Line, not the variant's Original photo.
       The leading underscore hides it from the customer's property list. */
    if(window.OL_WL && window.OL_WL.on && document.getElementById('olpWl')){
      item.properties={ 'Style':'White Line' };
      var wlArt=document.getElementById('olpWl').getAttribute('data-wl-img');
      /* image_url is protocol-relative; the order email needs a full URL. */
      if(wlArt) item.properties._art_image=(wlArt.indexOf('//')===0?'https:':'')+wlArt;
    }
    /* FLY route (fly-route-08l.js): the customer's two airports, for Ryan's print file. */
    if(window.OL_FLY && window.OL_FLY.active()){
      var fp=window.OL_FLY.props(); item.properties=item.properties||{};
      for(var fk in fp) item.properties[fk]=fp[fk];
    }
    return item;
  }

  function showAddError(err){
    var m = err && err.shopifyMsg;
    msg.className='olp__msg';
    if(!m || !/discount/i.test(m)){
      msg.textContent = m || ('Something went wrong'+DASH+'please try again.');
      return;
    }
    msg.textContent='';
    var line=document.createElement('span');
    line.textContent='A discount is still applied to your session, even though your cart may look empty. Heavies cannot be ordered with a discount applied.';
    var btn=document.createElement('button');
    btn.type='button'; btn.className='olp__fixdisc';
    btn.textContent='Remove my discount and add this';
    btn.addEventListener('click', function(){
      btn.disabled=true; btn.textContent='Removing...';
      fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({discount:''})})
        .then(function(r){ if(!r.ok) throw new Error('clear'); msg.textContent=''; form.requestSubmit(); })
        .catch(function(){ btn.disabled=false; btn.textContent='Remove my discount and add this';
          msg.appendChild(document.createTextNode(' Could not remove it automatically - please empty your cart and try again.')); });
    });
    msg.appendChild(line);
    msg.appendChild(document.createElement('br'));
    msg.appendChild(btn);
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    /* HARD STOP ON BLENDS. There is no submit button on a blend, but a stray
       form submit (Enter key, an app, a future edit) must never add a blend
       straight to the cart - it would arrive with NO PICKS attached, which is
       exactly the bug that shipped once before. The popup is the only route. */
    if(blendBtn || !addBtn) return;
    var v=findVariant(selectedOptions());
    if(!v||!v.available){ msg.className='olp__msg'; msg.textContent='Please choose an available option.'; return; }
    if(window.OL_FLY && window.OL_FLY.active()){
      var flyErr=window.OL_FLY.check();
      if(flyErr){ msg.className='olp__msg'; msg.textContent=flyErr; window.OL_FLY.focus(); return; }
    }
    addBtn.disabled=true; var was=addLabel.textContent; addLabel.textContent='Adding...'; msg.className='olp__msg'; msg.textContent='';
    var items=[buildItem(v)];
    /* the chosen frame rides in the same request, stamped with its print */
    var frameItem=window.OLFramePick ? window.OLFramePick.item(v, items[0], getQty()) : null;
    if(frameItem) items.push(frameItem);
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:items, sections:cartSectionIds().join(','), sections_url:location.pathname})})
      /* SHOW WHAT THE SERVER ACTUALLY SAID.
         Shopify rejects some adds with a 422 and a genuinely useful message in
         the body, e.g. the cart-validation rule on heavies:
           {"status":422,"message":"Unfortunately, no discounts can be used with
            our heavies. You'll need to remove the discount to proceed."}
         This used to throw that away and print "Something went wrong - please
         try again", so a customer with a discount in their session could never
         work out why a $4,900 print would not go in the cart, and the failure
         left no abandoned checkout to notice. Read the body, keep the message
         on the error, and print it. The generic line is now only the fallback
         for a real network failure or an unparseable response. */
      .then(function(r){
        if(!r.ok){
          return r.json().catch(function(){ return null; }).then(function(body){
            var err = new Error('add');
            err.shopifyMsg = readCartError(body);
            throw err;
          });
        }
        return r.json();
      })
      .then(function(res){ if(frameItem && window.OLFramePick) window.OLFramePick.added(); refreshCart(res); addBtn.disabled=false; addLabel.textContent=was;
        msg.className='olp__msg ok'; msg.textContent='Added to cart'+CHECK; })
      .catch(function(err){ addBtn.disabled=false; addLabel.textContent=was; showAddError(err); });
  });

  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
